// components
import CookiePolicy from '@components/Policy/cookiePolicy';
import PrivacyPolicy from '@components/Policy/privacyPolicy';
import TermsAndConditions from '@components/Policy/termsAndConditions';
import { useEffect, useState } from 'react';

const Policy = () => {
    const path = window.location.pathname;
    const [policyComponent, setPolicyComponent] = useState(null);

    useEffect(() => {
        if (path === "/terms") {
            setPolicyComponent(<TermsAndConditions />)
        } else if (path === "/privacy-policy") {
            setPolicyComponent(<PrivacyPolicy />)
        } else if (path === "/cookie-policy") {
            setPolicyComponent(<CookiePolicy />)
        }
    }, [path]);

    return (
        <main>
            <div className="section">
                <div className="container">
                    {policyComponent}
                </div>
            </div>
        </main>
    );
}

export default Policy;
